<template>
    <o-form-group
        :form-state="formState"
        :label="label"
        :message="errorMessages"
        :nolabel="nolabel"
        :type="{ 'is-danger': hasError }"
    >
        <b-form-textarea
            :class="input_class"
            :disabled="_is_readonly"
            v-bind="$attrs"
            v-bind:value="value"
            v-on="inputListeners"
        >
            <slot />
        </b-form-textarea>
    </o-form-group>
</template>

<script>
import FormComponentMixin from "../../../mixins/form_component_mixin";
import OFormGroup from "../OFormGroup";

export default {
    name: "OTextarea",
    components: { OFormGroup },
    mixins: [FormComponentMixin],
};
</script>

<style scoped></style>
